<template>
  <div class="users-list users-list-driverhelpers">
    <list-users :users="allDriverHelpers" type="driverhelpers" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ListUsers from '@/components/Admin/Users/components/list'

export default {
  name: 'DriverHelpersList',
  components: {
    ListUsers,
  },
  computed: {
    ...mapState('DriverHelpers', ['allDriverHelpers']),
  },
}
</script>

<style scoped>
.admins {
  width: 100%;
}
</style>
